import api from '../../plugins/api';

const getDealStatuses = (params) => {
  return api.get('/api/crm/deals/getDealStatuses', params);
};

export default getDealStatuses;
